import React from "react";
import { useSelector } from "react-redux";
import { useWatch } from "react-hook-form";

import { i18, trb } from "@utilities";
import {
  AddRemoveInputs,
  FullWidthInputWrapper,
  HalfWidthInputWrapper,
  StepperFormRow
} from "@components";
import { CheckboxFormField } from "@components/FormField/HookFormFields";
import { selectBusinessPartners } from "@redux";
import { BusinessPartner } from "../elements/BusinessPartner";

export const ClientMainBusinessPartners = ({
  control,
  unregister,
  totalBusinessPartners,
  setTotalBusinessPartners
}) => {
  const businessPartners = useSelector(selectBusinessPartners);
  const businessPartnerEmpty = useWatch({
    control,
    name: "clientBusPartner.0.clientBusPartnerEmpty"
  });

  const onCheckboxClick = e => {
    if (!e.target.checked) return;
    if (totalBusinessPartners > 1) {
      for (let i = 1; i < totalBusinessPartners; i++) {
        unregister(`clientBusPartner.${i}`);
      }
      unregister("clientBusPartner.0.data");
    } else {
      unregister("clientBusPartner.0.data");
    }
  };

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <p className="form-part-note">{trb(i18.Labels.MainBusPartner)}</p>
      </FullWidthInputWrapper>

      <HalfWidthInputWrapper>
        <CheckboxFormField
          control={control}
          name="clientBusPartner.0.clientBusPartnerEmpty"
          label={trb(i18.Labels.ClientBusPartnerEmpty)}
          onChange={onCheckboxClick}
          defaultValue={false}
        />
      </HalfWidthInputWrapper>

      {(businessPartnerEmpty === false || businessPartnerEmpty === "0") && (
        <>
          {new Array(totalBusinessPartners).fill(null).map((_, index) => (
            <BusinessPartner
              control={control}
              businessIndex={index}
              key={businessPartners[index]?.value}
            />
          ))}
          <AddRemoveInputs
            totalInputsAdded={totalBusinessPartners}
            maxInputsAllowed={businessPartners.length}
            onAdd={() => setTotalBusinessPartners(prev => prev + 1)}
            onRemove={() => {
              unregister(`clientBusPartner.${totalBusinessPartners - 1}`);
              setTotalBusinessPartners(prev => prev - 1);
            }}
          />
        </>
      )}
    </StepperFormRow>
  );
};
